import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  /* definition is spread out to be correctly understood by ie11 */\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n'], ['\n  /* definition is spread out to be correctly understood by ie11 */\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n']);

import styled from 'styled-components';

var GlobalNavigationPrimaryContainer = styled.div(_templateObject);

GlobalNavigationPrimaryContainer.displayName = 'GlobalNavigationPrimaryContainer';
export default GlobalNavigationPrimaryContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/GlobalNavigationPrimaryContainer.js
// module id = 604
// module chunks = 0